import { Button } from "@/components/ui/button";
import { MapPin, Phone, Mail, Clock, ExternalLink } from "lucide-react";

const contactInfo = [
  { icon: Mail, label: "Email", value: "info@incredglobalamc.sg", href: "mailto:info@incredglobalamc.sg" },
  { icon: Clock, label: "Hours", value: "Mon - Fri: 9:30 am - 6:30 pm" },
  { icon: Phone, label: "Phone", value: "+65 6022 8294", href: "tel:+6560228294" },
  { icon: Phone, label: "Phone", value: "+65 6022 8299", href: "tel:+6560228299" },
  { icon: MapPin, label: "Address", value: "112 Robinson Road, #12-01/02, Singapore, 068902" },
];

const ContactUs = () => {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 sm:py-32 bg-[#4A6670]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="mb-16">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#E87722] mb-4 font-body" data-testid="contact-overline">
            Get In Touch
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-white font-heading" data-testid="contact-title">
            Contact Us
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Contact info */}
          <div className="lg:col-span-6 space-y-8">
            {contactInfo.map((item, idx) => (
              <div key={idx} className="flex items-start gap-4" data-testid={`contact-info-${idx}`}>
                <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-white/10 rounded-sm">
                  <item.icon className="h-5 w-5 text-[#E87722]" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-white/60 uppercase tracking-wider font-body">{item.label}</p>
                  {item.href ? (
                    <a href={item.href} className="text-sm text-white mt-1 font-body hover:text-[#E87722] transition-colors">{item.value}</a>
                  ) : (
                    <p className="text-sm text-white mt-1 font-body">{item.value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="lg:col-span-6 flex flex-col justify-center">
            <div className="bg-white/5 border border-white/10 rounded-sm p-8 sm:p-12">
              <h3 className="text-xl font-medium text-white font-heading mb-4" data-testid="contact-cta-title">
                Reach Out to Us
              </h3>
              <p className="text-sm text-white/70 leading-relaxed font-body mb-8" data-testid="contact-cta-desc">
                For inquiries about our strategies, investment opportunities, or any general questions, please write to us. All inquiries will be responded to within 2 business days.
              </p>
              <Button
                asChild
                className="bg-[#E87722] hover:bg-[#D06A1E] text-white px-10 py-6 text-sm font-medium rounded-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
                data-testid="contact-email-button"
              >
                <a href="mailto:info@incredglobalamc.sg">
                  <Mail className="h-4 w-4 mr-2" />
                  Email Us
                  <ExternalLink className="h-3 w-3 ml-2 opacity-60" />
                </a>
              </Button>
            </div>

            <div className="mt-8">
              <p className="text-xs text-white/40 font-body leading-relaxed" data-testid="contact-disclaimer">
                InCred Global Asset Management Pte. Ltd. All inquiries will be responded to within 2 business days.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
